import * as React from 'react';

type BackButtonIconProps = React.SVGProps<SVGSVGElement>;

export const BackButtonIcon: React.FC<BackButtonIconProps> = React.memo(({ height = 12, width = 12, ...props }) => {
    return (
        <svg
            height={height}
            width={width}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='svg-icon'
            {...props}
        >
            <path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697L15.2197 3.96967C15.5126 3.67678 15.9874 3.67678 16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L9.31066 12L16.2803 18.9697C16.5732 19.2626 16.5732 19.7374 16.2803 20.0303C15.9874 20.3232 15.5126 20.3232 15.2197 20.0303L7.71967 12.5303Z'
            />
        </svg>
    );
});
